import PropTypes from 'prop-types'
import { useMemo, useRef } from 'react'
import { Input } from '.'
import { HandleClickOutside } from '../../HandleClickOutside'
import { Dropdown, positionDropdown } from '../../dropdown'
import { Element } from '../element'
import classes from './index.module.scss'

export const InputDropdown = ({
  children,
  placeHolder,
  containerStyle,
  style,
  dropdownContainerStyle,
  dropdownContentStyle,
  type,
  isShowDropdown,
  setIsShowDropdown,
  onClickOutsideDropdown,
  onClick,
  onBlur,
  onChange,
  onKeyDown,
  onClickIcon,
  value,
  alwaysActiveBorder,
  isShowIcon,
  zIndexDropdown,
  inputProps,
  scrollId,
  exceptRef,
  isShowIconSelect,
  styleIcon,
  isValid,
  textInvalid,
}) => {
  const inputRef = useRef()

  const getInputWidth = useMemo(() => {
    if (inputRef?.current) {
      return inputRef.current?.getBoundingClientRect().width
    }
    return 0
  }, [inputRef?.current?.getBoundingClientRect().width])

  return (
    <>
      <Input
        inputRef={inputRef}
        style={style}
        containerStyle={containerStyle}
        type={type}
        placeHolder={placeHolder}
        onClick={onClick}
        onBlur={onBlur}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onClickIcon={onClickIcon}
        value={value}
        alwaysActiveBorder={alwaysActiveBorder}
        isShowIcon={isShowIcon}
        isShowIconSelect={isShowIconSelect}
        styleIcon={styleIcon}
        isValid={isValid}
        textInvalid={textInvalid}
        {...inputProps}
      />
      {isShowDropdown && (
        <Dropdown
          parentRef={inputRef}
          position={positionDropdown.BOTTOM_START_RIGHT}
          appendStyle={{ width: getInputWidth, ...dropdownContainerStyle }}
          zIndex={zIndexDropdown}
          scrollId={scrollId}
          setIsShow={setIsShowDropdown}
        >
          <HandleClickOutside
            handleClickOutside={onClickOutsideDropdown}
            exceptRef={[inputRef, ...exceptRef]}
          >
            <Element
              elementName="div"
              style={{ backgroundColor: '#fff', ...dropdownContentStyle }}
              className={classes.inputDropdownContentContainer}
            >
              {children}
            </Element>
          </HandleClickOutside>
        </Dropdown>
      )}
    </>
  )
}

InputDropdown.propTypes = {
  children: PropTypes.node.isRequired,
  placeHolder: PropTypes.string,
  style: PropTypes.object,
  containerStyle: PropTypes.object,
  dropdownContainerStyle: PropTypes.object,
  type: PropTypes.string,
  isShowDropdown: PropTypes.bool,
  onClickOutsideDropdown: PropTypes.func,
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.string,
  alwaysActiveBorder: PropTypes.bool,
  zIndexDropdown: PropTypes.number,
  inputProps: PropTypes.object,
  exceptRef: PropTypes.array,
}

InputDropdown.defaultProps = {
  placeHolder: '',
  style: {},
  containerStyle: {},
  dropdownContainerStyle: {},
  type: 'text',
  isShowDropdown: false,
  onClickOutsideDropdown: () => {},
  alwaysActiveBorder: false,
  inputProps: {},
  exceptRef: [],
}
